import { mapActions } from 'vuex'

const Loading = {
  watch: {

  },
  methods: {
    ...mapActions({
      g_loadingInit: 'loading/loadingInit',
      g_loadingScreenPlus: 'loading/loadingScreenPlus',
      g_loadingScreenMinus: 'loading/loadingScreenMinus',
      g_loadingScreenReset: 'loading/loadingScreenReset',
      g_loadingPagePlus: 'loading/loadingPagePlus',
      g_loadingPageMinus: 'loading/loadingPageMinus',
      g_loadingPagenReset: 'loading/loadingPageReset'
    })
  }
}
export default Loading
